<template>
    <v-dialog v-model="handleDialog" width="1400" class="common-dialog" persistent>
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <validation-observer ref="observer" v-slot="{ invalid }" >
            <form @submit.prevent="pushOk">
                <v-card color="#F4FEFB">
                    <v-card-title class="justify-center">
                        <h2 v-if="id">承認者編集</h2><h2 v-else>承認者追加</h2>
                    </v-card-title>
                    <v-card-text class="common-dialog-message display-flex">
                        <v-container>
                            <v-row>
                                <v-col cols="12" xl="4">
                                    <badge-component tile content="任　意">
                                        <label-component>氏名</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="7">
                                    <validation-provider rules="max:100" name="destination_user_name">
                                        <v-text-field outlined filled readonly v-model="destination_user_name" tabindex="-1"></v-text-field>
                                    </validation-provider>
                                </v-col>
                                <v-col cols="12" xl="4">
                                    <badge-component tile content="任　意">
                                        <label-component>メールアドレス</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="7">
                                    <validation-provider rules="email|max:255" name="destination_email_address">
                                        <v-text-field outlined filled readonly v-model="destination_email_address" tabindex="-1"></v-text-field>
                                    </validation-provider>
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-container class="search-container" style="width:50%; max-width:50%;">
                            <v-row style="height:80px;">
                                <v-col class="display-flex">
                                    <v-text-field
                                        v-model="destination_search_name"
                                        append-icon="mdi-magnify"
                                        :height="20"
                                        placeholder="氏名での検索(部分一致)"
                                        outlined
                                        dense
                                        background-color="white"
                                        hide-details
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="member-area">
                                    <table class="membertable"><tbody>
                                        <tr class="membertable-row" 
                                            v-for="destinationUserNameRecord in filterDestinationRecords" 
                                            :key="destinationUserNameRecord.index" 
                                            @click="selected_reflect(destinationUserNameRecord)"
                                        >
                                            <td class="membertable-name">{{ destinationUserNameRecord.name }}</td>
                                            <td>{{ destinationUserNameRecord.email }}</td>
                                            <td class="membertable-company">{{ destinationUserNameRecord.company }}</td>
                                        </tr>
                                    </tbody></table>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    
                    <v-divider></v-divider>
                    
                    <v-card-actions class="justify-center grey lighten-4 pb-6">
                        <v-btn min-width="150px" class="white--text" color="red" large :disabled="invalid" @click="pushOk">
                            <slot name="ok-btn"></slot>
                        </v-btn>
                        <v-btn min-width="150px" class="white--text" color="blue-grey lighten-1" large @click="handleDialog = false;">
                            <slot name="cancel-btn"></slot>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </validation-observer>
    </v-dialog>
</template>

<script>
  import { email, max } from 'vee-validate/dist/rules';
  import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';

  extend('email', {
    ...email,
    message: '正しいメールアドレスをご入力ください',
  });

  extend('max', {
    ...max,
    message: '{length} 文字以内でご入力ください',
  });

export default {
    components: {
          ValidationProvider,
          ValidationObserver,
    },
    props: {
        sender: Object,
        currentAuthorizerList: Array,
        currentIndex: Number,
        currentItem: Object,
        // ダイアログの開閉
        authorizerDialog: Boolean,
    },
    data() {
        return {
            item: null,
            destination_search_name: '',
            destinationUserRecords: null,
            message: {
                success: false,
                text: '',
            },
        };
    },
    // 初期表示のデータ
    created : function() {
        this.item = {
            // id: '',
            id: this.currentItem.id?? '',
            destination_user_name: this.currentItem.destination_user_name?? '',
            destination_email_address: this.currentItem.destination_email_address?? '',
        };
        this.initDestinationUserNameRecord();
    },
    computed: {
        id: {
            get() {
                return this.item.id;
            },
        },
        destination_user_name: {
            get() {
                return this.item.destination_user_name;
            },
            set(value) {
                this.item.destination_user_name = value;
            }
        },
        destination_email_address: {
            get() {
                return this.item.destination_email_address;
            },
            set(value) {
                this.item.destination_email_address = value;
            }
        },
        destination_company_name: {
            get() {
                return this.item.destination_company_name;
            },
            set(value) {
                this.item.destination_company_name = value;
            }
        },
        filterDestinationRecords: function() { 
            let self = this;
            
            if (self.destination_search_name===null||self.destination_search_name==="") {
                return self.destinationUserRecords;
            }
            let destUserNameRecords = self.destinationUserRecords.filter(
                function (destinationUserRecordsFiltered) {
                    return destinationUserRecordsFiltered.name.includes(self.destination_search_name);
                }
            );
            return destUserNameRecords;
        },
        handleDialog: {
            get() {
                return this.authorizerDialog;
            },
            set(value) {
                // 親コンポーネントへの通知
                this.$emit('update:authorizerDialog', value);
            }
        },
        isMessage: {
            get() {
                return this.message.text != '';
            },
            set(value) {
                if (!value) {
                    this.message.text = '';
                }
            }
        },
    },
    methods: {
        // 更新
        pushOk: function() {
            let self = this;
            this.$refs.observer.validate().then((result) => {
                if(result) {
                    if (self.item.destination_email_address != null && self.item.destination_email_address != '') {
                        let find = self.currentAuthorizerList.find(item => item.destination_email_address == self.item.destination_email_address);
                        if (find != null && self.currentAuthorizerList.indexOf(find) != self.currentIndex) {
                            self.message.text = "すでに宛先に設定されているメールアドレスです";
                            self.message.success = false;
                            return false;
                        }
                    }
                    // 親コンポーネントへの通知
                    self.$emit("clickOk", self.item);
                    self.handleDialog = false;
                }
            });
        },
        // 検索
        async initDestinationUserNameRecord() {
            let self = this;
            var result = await window.axios.get('/documents/document-management/template/company_authorizer_members', {
                params: {
                    name: self.destination_search_name?? '',
                }
            });
            self.destinationUserRecords = result.data.records;
        },
        // 選択行の反映
        async selected_reflect(destinationUserNameRecord) {
            this.item.destination_user_name = destinationUserNameRecord.name;
            this.item.destination_email_address = destinationUserNameRecord.email;
            this.item.destination_company_name = destinationUserNameRecord.company;
        },
    },
};
</script>

<style scoped>
    .confirm-message {
        text-align: center;
    }
    .search-container {
        border: 1px solid #aaa;
        border-radius: 6px;
    }
    .member-area {
        margin-top: -30px;
        overflow: auto;
        height: 350px;
    }
    .membertable {
        border-collapse: collapse;
        width: 620px;
    }
    .membertable-row {
        border-top: 1px solid #aaa;
        border-bottom: 1px solid #aaa;
    }
    .membertable-row:hover {
        cursor:pointer;
        background-color: #ddd;
        transition: all  0.3s ease;
    }
    .membertable-name {
        padding: 10px;
        width: 170px;
        font-weight: bold;
    }
    .membertable-company {
        display:none;
    }
    .display-flex {
        display: flex;
    }
</style>